import { css, Theme } from "@emotion/react"

export const MuiAppBar = (theme: Theme) => css`
    background-color: white;
    box-shadow: none;
    border-bottom: 1px solid ${theme.palette.Midnight[10]};
    position: inherit;
`

export const MuiToolbar = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
`

export const MuiToolbarRight = (theme: Theme) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    gap: ${theme.spacing(2)};
`
